import { AppState } from "../reducers/rootReducer";

export const getAllSections = (state: AppState) => state.sectionList;
export const getSectionsByRowId = (rowId:String) => (state: AppState) => { return state.sectionList.filter((section) => section.rowId === rowId)};